import { render, staticRenderFns } from "./RealtimeHistogramSettings.vue?vue&type=template&id=6a7ad297"
import script from "./RealtimeHistogramSettings.vue?vue&type=script&lang=js"
export * from "./RealtimeHistogramSettings.vue?vue&type=script&lang=js"
import style0 from "./RealtimeHistogramSettings.vue?vue&type=style&index=0&id=6a7ad297&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports